export namespace HelpdeskToolkitActions {
    export class Test {
        public static readonly type = "[Helpdesk Toolkit] Test";

        constructor(public isTest: boolean) {}
    }
}
